import { PayloadAction, createSlice } from 'ngrx-slice';

import { VipDiscountDto } from '@app/api/marketplace/models';

export interface State {}
export const initialState: State = {};

export const {
  actions: VipDiscountsActions,
  selectors,
  ...VipDiscountsFeature
} = createSlice({
  name: 'vipDiscounts',
  initialState,
  reducers: {
    loadOriginalPrice: {
      trigger: (
        _state,
        _action: PayloadAction<{
          discount: VipDiscountDto;
          isRequestedAsDiscountReceiver: boolean;
        }>
      ) => {},
      success: () => {},
    },
    reset: (_) => initialState,
  },
});

export const VipDiscountsSelectors = {
  ...selectors,
};
